<script>


import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import TwImg from '@/components/images/tw-img.vue'

export default {
  name: 'FundraiserCard',
  components: { TwImg, TwTimeLeft, TwButton },
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
  computed: {
    raisedFormatted() {
      return this.$filters.formatCurrency(this.fundraiser.cached?.raised, this.fundraiser.currency)
    }
  }
}
</script>

<template>
  <router-link :to="{ name: 'FundraiserPublicPage', params: { fundraiserId: fundraiser.id, slug: fundraiser.slug }}">
    <div class="bg-gray-900 text-white rounded-2xl shadow-sm flex flex-col overflow-hidden h-full">
      <!-- Image -->
      <div class="h-full max-h-52">
        <tw-img :src="fundraiser.cover_image_url" :alt="fundraiser.title" class="w-full h-full object-cover max-h-52" />
      </div>

      <!-- Content -->
      <div class="p-6 flex flex-col justify-between h-full">
        <div class="mb-6">
          <h4>
            {{ fundraiser.title }}
          </h4>
          <p class="text-gray-400 text-sm mt-1">
            <!-- 35 Group Members Raising Money -->
            35 fundraisers
          </p>
        </div>
        <div>
          <div class="flex justify-between items-end w-full mb-3 gap-2">
            <h3 class="text-amber-500">
              {{ raisedFormatted }}
              <span class="text-sm font-normal text-white">Raised</span>
            </h3>
            <h5 class="text-amber-500">
              {{ fundraiser.cached.percentage_raised }}%
            </h5>
          </div>
          <!-- Progress Bar -->
          <div :class="['relative w-full h-3 bg-gray-600 rounded-full overflow-hidden mb-1',{'mb-14':!fundraiser.deadline}]">
            <div class="absolute h-full bg-amber-500" :style="`width: ${fundraiser.cached.percentage_raised}%;`" />
          </div>
          <!-- Countdown Section -->
          <tw-time-left v-if="fundraiser.deadline" class="text-sm mb-7" :deadline="fundraiser.deadline" detailed />
          <!-- <p class="font-bold text-yellow-400 mb-4">
          {{ fundraiser.cached.percentage_raised }}% Funded
        </p> -->
          <!-- Button -->
          <tw-button target="_blank" :to="{ name: 'FundraiserPublicPage', params: { fundraiserId: fundraiser.id, slug: fundraiser.slug }}" variant="medium" class="flex justify-center">
            View Campaign
          </tw-button>
        </div>
      </div>
    </div>
  </router-link>
</template>

<style scoped>

</style>
